<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Ride Requests</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Ride Requests
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="users-view">
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>Ride Request Id:</td>
                                            <td>{{ trip_request.id }}</td>
                                        </tr>
                                        <tr>
                                            <td>Pickup Address:</td>
                                            <td>{{ trip_request.pickup_address }}</td>
                                        </tr>
                                        <tr>
                                            <td>Drop Address:</td>
                                            <td>{{ trip_request.drop_address }}</td>
                                        </tr>
                                        <tr>
                                            <td>Request Initiated at:</td>
                                            <td>{{ formatDateTime(trip_request.created_at) ?? "NIL" }}</td>
                                        </tr>
                                        <tr>
                                            <td>Request Accepted at:</td>
                                            <td>{{ formatDateTime(trip_request.driver_accepted_at) ?? "NIL"}}</td>
                                        </tr>
                                        <tr>
                                            <td>Request Cancelled at:</td>
                                            <td>{{ formatDateTime(trip_request.cancelled_at) ?? "NIL" }}</td>
                                        </tr>
                                        <tr>
                                            <td>Driver Arrived at:</td>
                                            <td>{{ formatDateTime(trip_request.driver_arrived_at) ?? "NIL" }}</td>
                                        </tr>
                                        <tr>
                                            <td>Driver Name:</td>
                                            <td>
                                                {{ trip_request.driver ? trip_request.driver?.first_name + " " + trip_request.driver?.last_name : "NIL"}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Driver Email:</td>
                                            <td>{{ trip_request.driver?.email ?? "NIL" }}</td>
                                        </tr>
                                        <tr>
                                            <td>Driver Phone:</td>
                                            <td>{{ trip_request.driver?.phone_number ?? "NIL" }}</td>
                                        </tr>
                                        <tr>
                                            <td>User Name:</td>
                                            <td>{{ trip_request.passenger?.first_name + " " + trip_request.passenger?.last_name }}</td>
                                        </tr>
                                        <tr>
                                            <td>User Email:</td>
                                            <td>{{ trip_request.passenger?.email }}</td>
                                        </tr>
                                        <tr>
                                            <td>User Phone:</td>
                                            <td>{{ trip_request.passenger?.phone ?? "NIL" }}</td>
                                        </tr>
                                        <tr>
                                            <td>Status:</td>
                                            <td>
                                                <span :class="'users-view-status badge badge-' + statusClass(trip_request.status)">
                                                    {{ trip_request.status }}
                                                </span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'Trip Request'},
    name: 'TripRequestShow',
    props: ['trip_request'],
    layout: Layout,
    data: () => ({
        saving: false
    }),
    methods: {
        formatDateTime(value) {
            if (!value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        statusClass(value) {
            if (value === 'pending') {
                return "warning";
            } else if (value === 'accepted' || value === 'in_progress' || value === 'picked_up' || value === 'in_transit')
            {
                return "success";
            } else if (value === 'completed')
            {
                return "primary";
            } else {
                return "danger";
            }
        },
    },
    mounted() {

    },
}
</script>
